// src/hooks/useScrollEffects.js
import { useState, useEffect } from 'react';

const useScrollEffects = (mainRef, footerRef) => {
    const [mainBnEffect, setMainBnEffect] = useState(false);
    const [footEffect, setFootEffect] = useState(false);
    // const [stickyPicStatus, setStickyPicStatus] = useState(''); // '', 'fixed' 或 'leave'

    useEffect(() => {
        const onScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            // mainBnEffect：當滾動超過 50 時啟動效果，回到 550 以下時移除（根據原本邏輯，可根據需求調整）
            setMainBnEffect(scrollTop > 50);

            // footer effect：根據 main 元素與 footer 位置計算
            if (mainRef.current && footerRef.current) {
                const mainRect = mainRef.current.getBoundingClientRect();
                const triggerPoint = mainRect.bottom;
                const progress = Math.min(Math.max((window.innerHeight - triggerPoint) / 150, 0), 1);
                setFootEffect(progress >= 0.8);
            }


            // stickyPic：假設 stickyPic 與 areaInformation 元素存在
            // const stickyPicEl = document.querySelector('.sticky_pic');
            // const areaInfoEl = document.querySelector('.areaInformation');
            // if (stickyPicEl && areaInfoEl) {
            //     const areaRect = areaInfoEl.getBoundingClientRect();
            //     const stickyPicHeight = stickyPicEl.offsetHeight;
            //     const bufferDistance = 450;
            //     if (
            //         areaRect.top <= window.innerHeight - stickyPicHeight - bufferDistance &&
            //         areaRect.bottom > stickyPicHeight + bufferDistance
            //     ) {
            //         setStickyPicStatus('fixed');
            //     } else if (areaRect.bottom <= stickyPicHeight + bufferDistance) {
            //         setStickyPicStatus('leave');
            //     } else {
            //         setStickyPicStatus('');
            //     }
            // }
        };

        window.addEventListener('scroll', onScroll);
        // 初始化一次
        onScroll();
        return () => window.removeEventListener('scroll', onScroll);
    }, [mainRef, footerRef]);

    return { mainBnEffect, footEffect };
};

export default useScrollEffects;
